class Price {
    static nullPrice() {
        return new Price(0, '')
    }

    constructor(decimal, frequency) {
        this._decimal = decimal
        this._frequency = frequency
    }

    get price() {
        return this._decimal
    }

    get frequency() {
        return this._frequency
    }
    
    asObject () {
        return {
            price: this.price,
            frequency: this.frequency
        }
    }
}

export default Price 


// WEBPACK FOOTER //
// ./Scripts/App/Hosting/Classes/Price.es6